/**
 * `controller/config_audit/scopes.py` writes two shapes: a whole value
 * replaced with `***`, and `://***@` inside a URL. Matching `***` anywhere
 * over-reports, because watched free text like situation notes can hold
 * `***-***-1234` or `***bold***`.
 */
const REDACTED = '***';

function isRedactedValue(value: unknown): boolean {
  return (
    typeof value === 'string' &&
    (value === REDACTED || value.includes(`://${REDACTED}@`))
  );
}

/** Walks the document rather than stringifying it. */
export function isRedacted(value: unknown): boolean {
  if (isRedactedValue(value)) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.some(isRedacted);
  }
  if (typeof value === 'object' && value !== null) {
    return Object.values(value).some(isRedacted);
  }
  return false;
}
